module.exports = __webpack_public_path__ + "img/Telegram_logo.56a89006.svg";